import type { ComponentProps } from 'react';

export default function CheckIconLarge(props: ComponentProps<'svg'>) {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M8.52893 10.813L5.6305 7.96217L3.5 10.0569L8.52893 15L16.5 7.16564L14.443 5L8.52893 10.813Z"
                fill="currentColor"
            />
        </svg>
    );
}
